<template>
    <v-select 
       :value="selected_type" 
       v-bind:items="types"
       prepend-icon="mdi-filter-outline" 
       item-value="code" 
       item-text="description" 
       label="Select type"
       dense class="pl-3 pt-1"
       @change="getSelection">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_type: {
           type: String,
           default: 'all'
        },
        field :{
            type: String,
            default: 'sel_type'
        }    
    },
    data() {
        return {
            types: [],
        }
    },
    created() {
        this.getTypeInfo();
    },
    methods: {
        getTypeInfo() {
            this.types = [
                {code: 'online', description: 'Online'},
                {code: 'offline', description: 'Offline'},
                {code: 'all', description: 'All'},   
            ]    
        },
        getSelection(v){
            this.$emit('getSelection', { "field": this.field, "value": v === null ? 'all' : v })
        }
    }
}

</script>


